import { useLocation, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { parseQueryString, objectToQuery } from "../../helpers";

export default function useCurrentCategory() {

	const queryCategory = useSelector(state => state.session.query.c)
	const [category, setCategory] = useState(queryCategory || null);
	const location = useLocation();
	const history = useHistory();

	function changeCategory(newCategory) {
		if (newCategory === category) return;
		history.push({
			...location,
			search: (search => {
				const query = parseQueryString(search);
				query.c = newCategory;
				return objectToQuery(query);
			})(location.search)
		});
	}

	useEffect(() => {
		let match = /c=([^?&=]+)/.exec(location.search);
		match = match ? decodeURIComponent(match[1]) : null;
		if (match !== category) setCategory(match);
	}, [location, category]);

	return [category, changeCategory];
}